import React, { useLayoutEffect, useRef } from "react";
import { ComponentBarContainer } from "./ComponentBarStyles";
const ComponentBar = ({ height, setHeight, top, children }) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (height) {
            if (typeof height === "string") {
                setHeight(parseInt(height.replace(/[^0-9]/g, "")));
            }
            else {
                setHeight(height);
            }
        }
        else if (ref.current && setHeight) {
            setHeight(ref.current.offsetHeight);
        }
    }, [ref, height, setHeight]);
    return (React.createElement(ComponentBarContainer, { top: top, ref: ref }, children));
};
export default ComponentBar;
//# sourceMappingURL=ComponentBar.js.map